/* Shared layout for the home-page horizontal carousels (events, experiences,
   articles). Mirrors src/hooks/use-breakpoint.ts (Breakpoints.lg=1024) and
   src/constants/theme.ts (Spacing.two=8, Spacing.three=16).

   The native versions (events-carousel.tsx etc.) pick these values with a JS
   `isLg` check that only resolves after mount, so on the web export they
   render mobile-first (smaller heading, tighter section gap, edge padding)
   and snap to desktop a moment later — a vertical shift of ~12px per section
   that stacks down the page. Driving them with CSS media queries lets the
   browser resolve the final layout at first paint. */

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* Edge padding on mobile; the desktop grid column already insets the page. */
  padding: 0 16px;
}

@media (min-width: 1024px) {
  .section {
    gap: 16px;
    padding: 0;
  }
}

.heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.headingText {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

@media (min-width: 1024px) {
  .headingText {
    font-size: 24px;
  }
}

.carouselWrap {
  position: relative;
}

/* Horizontal scroller. overflow-x:auto gives native touch/trackpad scrolling;
   the arrow buttons drive it via scrollBy() on this element's ref. */
.scroller {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
}

.scroller::-webkit-scrollbar {
  display: none;
}

@media (min-width: 1024px) {
  .scroller {
    gap: 16px;
  }
}

/* Arrow buttons are desktop-only; they position absolutely against
   .carouselWrap, so this wrapper only needs to toggle their visibility. */
.arrows {
  display: none;
}

@media (min-width: 1024px) {
  .arrows {
    display: block;
  }
}

.statusText {
  font-size: 14px;
}

/* For carousels placed inside a column that already has its own gutters
   (the city page's content column) — drops .section's mobile edge padding. */
.flush {
  padding: 0;
}

.description {
  margin: 0;
  /* A raw <p>, so it needs react-native-web's Text font stack spelled out. */
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 26px;
}
